import React, { useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Button, Grid, TextField, Typography } from "@mui/material";
import authAxios from "setups/axios";
import { toastMessage } from "utils/toastMessage";
import toast, { Toaster } from "react-hot-toast";
import DownloadIcon from '@mui/icons-material/Download';
import { PageHeader, SectionCard } from "_shared/ui";

const Main = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loadingAll, setLoadingAll] = useState(false);

  // NOTE: Old SE report download (single-template report) is deprecated in favour
  // of the "Download All Visits" report below. Kept commented for reference.
  // const handleDownload = async () => {
  //   if (!startDate || !endDate) {
  //     toastMessage("Please select both Start Date and End Date.", "error");
  //     return;
  //   }
  //
  //   if (new Date(startDate) > new Date(endDate)) {
  //     toastMessage("Start Date should be less than End Date.", "error");
  //     return;
  //   }
  //
  //   setLoading(true);
  //   try {
  //     const response = await authAxios()({
  //       url: `/api/v1/report/corReportSE/download?startDate=${startDate}&endDate=${endDate}`,
  //       method: "GET",
  //       responseType: "blob",
  //     });
  //
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `SE_Report_${startDate}_to_${endDate}.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     toastMessage("Report downloaded successfully!", "success");
  //   } catch (err) {
  //     console.log("error", err);
  //     toastMessage("Failed to download report.", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleDownloadAll = async () => {
    // Dates are optional for the All Visits report. If both provided, validate order.
    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      toastMessage("Start Date should be less than End Date.", "error");
      return;
    }

    setLoadingAll(true);
    try {
      const params = new URLSearchParams();
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      const query = params.toString() ? `?${params.toString()}` : "";

      const response = await authAxios()({
        url: `/api/v1/report/corReportSE/downloadAll${query}`,
        method: "GET",
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const range = startDate && endDate ? `_${startDate}_to_${endDate}` : "";
      link.setAttribute("download", `SE_All_Visits${range}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toastMessage("Report downloaded successfully!", "success");
    } catch (err) {
      console.log("error", err);
      toastMessage("Failed to download report.", "error");
    } finally {
      setLoadingAll(false);
    }
  };

  return (
    <>
      <PageHeader
        title="SE Reports"
        subtitle="Export SE visit data as an Excel report"
      />
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={8}>
          <SectionCard title="Download SE Report">
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
              Download all SE visit data (all visit types + daily calls) in one Excel file.
              Date range is optional &mdash; leave both blank to export everything.
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  label="Start Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  label="End Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleDownloadAll}
                  disabled={loadingAll}
                  endIcon={<DownloadIcon />}
                >
                  {loadingAll ? "Downloading..." : "Download All Visits"}
                </Button>
              </Grid>
            </Grid>
          </SectionCard>
        </Grid>
      </Grid>
    </>
  );
};

const SEReports = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN", "ADMINSE"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default SEReports;
